<template>
    <div v-if="$scope.CART_FOR_CUSTOMER_NAME || customer">
        Você está comprando para:
        <a href="/minha-conta/clientes" class="ml-0">
            <strong>{{customer ? customer.full_name : $scope.CART_FOR_CUSTOMER_NAME}}</strong>
        </a>
    </div>
</template>

<script>
    import {cartStore} from "../../common/store/cart-store";

    export default {
        name: "SalesRepBuyingFor",

        data() {
            return {
                cartStoreState: cartStore.state
            }
        },

        computed: {
            customer() {
                return ((this.cartStoreState.cart || {}).customer || {}).data;
            }
        }
    }
</script>